<template>
    <div class="email-opens-widget">
        <div class="widget-header">
            <h3>Opens</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div class="loading-container" v-if="loading">
                <loading-screen-svg />
            </div>
            <div v-else>
                <div class="content-title">
                    <span @click="goToContact()" class="contact-link"><img class="profile-image" :src="contact.profileImageUrl | profileImagePlaceholder" /> {{ contact.fullName }}</span> Opens ({{ totalOpens }})
                </div>
                <email-opens-display 
                    :contactId="contact.id"
                    :messageId="messageId" />
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget()">
                    Cancel
                </app-button>
            </div>
            <div class="action-container">
                <app-button class="save-btn" @click="closeWidget()">
                    Done
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const EmailOpensDisplay = () => import('@/components/email/email-opens-display');

import EventBus from '@/scripts/event-bus.js';
import log from '@/scripts/logger';

export default {
    name: 'email-opens-widget',

    props: {
        widget: {
            type: Object,
            required: true
        },
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
        'email-opens-display': EmailOpensDisplay
    },

    data() {
        return {
            loading: true,
            messageId: this.widget.messageId,
            contact: {
                id: this.widget.contactId,
                profileImageUrl: null,
                fullName: null
            },
            totalOpens: 0,
        }
    },

    computed: {

    },

    methods: {
        goToContact() {
            this.$router.push(`/Contacts/${ this.contact.id }`);
            this.closeWidget();
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        getContact() {
            return new Promise((resolve, reject) => {
                this.$api
                    .get(`/service/Contacts(${ this.contact.id })?$select=ProfileImageUrl,FirstName,LastName`)
                    .then(response => {
                        var contactResponse = response.data;

                        this.contact.profileImageUrl = contactResponse.ProfileImageUrl || require('@/assets/images/avatar.png');
                        this.contact.fullName = this.$helpers.getName(contactResponse.FirstName, contactResponse.LastName);
                        
                        resolve();
                    })
                    .catch((error) => {
                        const message = 'An error occurred while fetching your contact';
                        log.error(message, error);
                        reject(message);
                    }); 
            });
        },

        getMessageOpensCount() {
            var query = `/service/OpenActivities?$filter=ContactId eq ${ this.contact.id } and MessageId eq ${ this.messageId }&$count=true&$top=0`;

            this.$api
                .get(query)
                .then(response => {
                    this.totalOpens = response.data['@odata.count'];
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while fetching your opens.', { error });
                })
                .finally(() => {
                    this.loading = false;
                });  
        }
    },

    created() {
        this.getContact()
            .then(this.getMessageOpensCount);
    },

}
</script>

<style>
.email-opens-widget .content-title {
    font: bold 20px/1em 'Nunito';
}

.email-opens-widget .contact-link {
    color: #18AEFF;
    cursor: pointer;
}

.email-opens-widget .content-title .profile-image {
    height: auto;
    max-height: 100%;
    border-radius: 50%;
    max-width: 32px;
    margin-right: 8px;
}

.email-opens-widget .content-wrapper {
    padding: 20px;
}

.email-opens-widget .action-container {
    display: flex;
}

.email-opens-widget .action-container .btn {
    margin-left: 15px;
}

.email-opens-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.email-opens-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.email-opens-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}
</style>
